import {gistActionTypes, sourceActionTypes} from '../_constants';
import {sourceHelper} from "../_helpers";

export function currentSource(state = {}, action) {
  switch (action.type) {

      // deactivate a source request
    case sourceActionTypes.DEACTIVATE_SOURCE_REQUEST:
      return {
        ...state,
        deactivating: true
      };

      // deactivate a source success
    case sourceActionTypes.DEACTIVATE_SOURCE_SUCCESS:
      return {
        ...state,
        deactivated: true,
        selectedItem: action.updatedSource
      };

      // deactivate a source failure
    case sourceActionTypes.DEACTIVATE_SOURCE_FAILURE:
      return {
        ...state,
        deactivated: false,
        deactivating: false
      };

      // activate a source request
    case sourceActionTypes.ACTIVATE_SOURCE_REQUEST:
      return {
        ...state,
        activating: true
      };

      // activate a source success
    case sourceActionTypes.ACTIVATE_SOURCE_SUCCESS:
      return {
        ...state,
        activated: true,
        selectedItem: action.updatedSource
      };

      // activate a source failure
    case sourceActionTypes.ACTIVATE_SOURCE_FAILURE:
      return {
        ...state,
        activated: false,
        activating: false
      };

    // set current source
    case sourceActionTypes.SET_CURRENT_SOURCE:
      return {
        selectedItem : action.item,
        selectedGist: false
      };

    // get new source order success
    case sourceActionTypes.ORDER_SOURCE_SUCCESS:
      return {
        selectedItem: sourceHelper.parseSources(action.source),
        selectedGist: false
      }

      // get gist request
    case gistActionTypes.GET_SOURCE_GIST_REQUEST:
      return {
        ...state,
        selectedGist: {
          loading: true
        }
      };

      // get gist success
    case gistActionTypes.GET_SOURCE_GIST_SUCCESS:
      return {
        ...state,
        selectedGist: {
          loaded: true,
          gist: action.gist
        }
      };

      // get gist failure
    case gistActionTypes.GET_SOURCE_GIST_FAILURE:
      return {
        ...state,
        selectedGist: {
          loaded: false
        }
      };

    case gistActionTypes.UNSET_SOURCE_CURRENT_GIST:
      return {
        ...state,
        selectedGist: false
      };

    case sourceActionTypes.EDIT_SOURCE_REQUEST:
      return {
        ...state,
        isEditing: true,
      };

    case sourceActionTypes.EDIT_SOURCE_SUCCESS:
      return {
        ...state,
        isEditing: false,
        editSuccess: true,
        selectedItem: action.updatedSource
      };

    case sourceActionTypes.EDIT_SOURCE_FAILURE:
      return {
        ...state,
        isEditing: false,
        editSuccess: false,
      };

    default:
      return state
  }
}